/**
 * @generated SignedSource<<04c4b24b52d5490d9e771393bb4a0fcc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type initSurveyRefundHistoryIdQuery$variables = Record<PropertyKey, never>;
export type initSurveyRefundHistoryIdQuery$data = {
  readonly getRefundHistoryId: {
    readonly refundHistoryId: string;
    readonly result: boolean;
  };
};
export type initSurveyRefundHistoryIdQuery = {
  response: initSurveyRefundHistoryIdQuery$data;
  variables: initSurveyRefundHistoryIdQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "GetRefundHistoryIdOutput",
    "kind": "LinkedField",
    "name": "getRefundHistoryId",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "result",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "refundHistoryId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "initSurveyRefundHistoryIdQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "initSurveyRefundHistoryIdQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "7c150b950079968819f3ce4a2c44fa45",
    "id": null,
    "metadata": {},
    "name": "initSurveyRefundHistoryIdQuery",
    "operationKind": "query",
    "text": "query initSurveyRefundHistoryIdQuery {\n  getRefundHistoryId {\n    result\n    refundHistoryId\n  }\n}\n"
  }
};
})();

(node as any).hash = "0822369243a9113d796bccbd8b514bf0";

export default node;
